import { Box, Button, Card, CardActions, CardContent, CardMedia, Grid, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Typography } from "@mui/material";
import MenuFrame from "../frames/menu_frame";
import { motion } from "framer-motion";
import { StarTwoTone } from "@mui/icons-material";
import "./price.css";

function Pricing() {
    const plans = [
        {
            name: "Monthly",
            price: "10,000",
            image: "/img/sky.jpg",
            features: ["10 Year Data Retention", "Client Area", "Employee Area", "Smart Billing", "24/7 Support"],
            active: false,
        },
        {
            name: "Quarterly",
            price: "20,000",
            image: "/img/blue.jpg",
            features: ["10 Year Data Retention", "Client Area", "Employee Area", "Smart Billing", "24/7 Support"],
            active: true,
        },
        {
            name: "Annual",
            price: "60,000",
            image: "/img/fields.jpg",
            features: ["10 Year Data Retention", "Client Area", "Employee Area", "Smart Billing", "24/7 Support"],
            active: false,
        },
    ];

    return (
        <MenuFrame screen="PRICING" login={false}>
            <Box sx={{pb: 20}}>
            <motion.div initial={{ y: 30 }} animate={{ y: 0 }} transition={{ type: "spring", duration: 1.5 }}>
                <Typography variant="h2" sx={{ textAlign: "center", fontWeight: "bold", color: "text.primary", mt: 5 }}>Pricing</Typography>
            </motion.div>
            <motion.div initial={{ y: 30 }} animate={{ y: 0 }} transition={{ duration: 1 }}>
                <Typography variant="subtitle1" sx={{ textAlign: "center", color: "text.secondary", mb: 5 }}>Get the convinent pricing for service.</Typography>
            </motion.div>
            
                <Grid container spacing={10} sx={{ mt: 2 }}>
                    {
                        plans.map((plan, idx) =>
                            <Grid size={{ md: 12, lg: 4 }} key={idx}>
                                <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }} transition={{ type: "spring" }}>
                                    <Card p={2}>
                                        <CardMedia sx={{ height: 140 }} image={plan.image} title={plan.name} />
                                        <CardContent>
                                            <Typography gutterBottom variant="subtitle1" component="div">
                                                {plan.name}
                                            </Typography>
                                            <Typography gutterBottom variant="h5" component="div" color="success">
                                                ₹ {plan.price}
                                            </Typography>
                                            <Typography variant="body2" sx={{ color: 'text.primary' }}>
                                                Lizards are a widespread group of squamate reptiles, with over 6,000
                                                species, ranging across all continents except Antarctica
                                            </Typography>
                                            <List>
                                                {plan.features.map((ftr, k) =>
                                                    <ListItem disablePadding key={k}>
                                                        <ListItemButton>
                                                            <ListItemIcon>
                                                                <StarTwoTone color="warning" />
                                                            </ListItemIcon>
                                                            <ListItemText primary={ftr} />
                                                        </ListItemButton>
                                                    </ListItem>
                                                )
                                                }
                                            </List>
                                        </CardContent>
                                        <CardActions style={{ display: "flex", justifyContent: "center" }}>
                                            <Button size="large" variant="outlined" color="secondary" style={{ textTransform: "none", borderRadius: "100px" }}>Purchase</Button>
                                        </CardActions>
                                    </Card>
                                </motion.div>
                            </Grid>
                        )
                    }
                </Grid>
            </Box>
        </MenuFrame>
    );
}

export default Pricing;
